import { buildFacetDesignOverride } from 'Packages/FacetRest/FacetDesignOverride';

export const ClientMetaOverrideSet = buildFacetDesignOverride();
